import { setViewportUnits, EditableSvg, scrollToHash, addBgColorVariable, initHeaderHeight } from './utils/utilities.js';
import { Offcanvas } from './global/offcanvas';
import { Header } from './global/header';
import { DropdownMenu } from './global/dropdownMenu';
import { Tabs } from './global/tabs';
import { Animations } from './global/animations.js';
import { RanchesFeed } from './blocks/ranches-feed';
import { SiteHeaderNav } from './global/megaMenu';
import { OffcanvasNav } from './global/offcanvasMegaMenu';
import { Video } from './blocks/video.js';
import { SectionWrapper } from './blocks/sectionWrapper.js';
import { initGalleryCarousel } from './blocks/thumbs-gallery.js';
import { LogoWall } from './blocks/logo-wall.js';
import { TeamMembersNav } from './blocks/team-members.js';
import { Testimonials } from './blocks/testimonials.js';
import { ScrollJacking } from './blocks/scroll-jacking.js';
import { Statistic } from './blocks/statistic.js';
import { initBrokerModals } from './blocks/brokers.js';
import { initRanchBrochureModal } from './blocks/ranch-buttons.js';
import { Accordion } from './blocks/accordion.js';
import { ContentFeed } from './blocks/content-feed.js';
import { PodcastFeed } from './blocks/podcast-feed.js';
import { PostPreview } from './blocks/post-preview.js';
import { initImageGallery } from './blocks/image-gallery.js';
import { ShareInfo } from './blocks/share-info.js';
import { FilterNavigation } from './blocks/filter-navigation/filter-navigation.js';
import { InteractiveMap } from './blocks/interactive-map/interactive-map.js';
import { Favorites } from './blocks/favorites.js';
import { initGroupReadMore } from './blocks/group.js';
import { SearchModal } from './global/search.js';

const onDomReady = (callback) => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
        callback();
    }
};

onDomReady(async () => {
    setViewportUnits();

    scrollToHash();

    addBgColorVariable();

    initHeaderHeight();

    Array.from(document.querySelectorAll('.editable-svg')).map((img) => EditableSvg(img));

    Header(document.querySelector('.site-header'));

    SearchModal();

    DropdownMenu();
    SiteHeaderNav();
    OffcanvasNav();

    const offcanvas = document.querySelector('.offcanvas');
    if (offcanvas) {
        new Offcanvas(offcanvas);
    }

    // Init Group read more
    initGroupReadMore();

    // Always initialize Lenis for smooth scroll
    const lenis = Animations();

    // Store Lenis instance globally for other modules
    if (lenis) {
        window.lenisInstance = lenis;
    }

    // blocks
    RanchesFeed();
    Video();
    SectionWrapper();
    initGalleryCarousel();
    Tabs();
    Testimonials();
    TeamMembersNav();
    LogoWall();
    Statistic();
    ContentFeed();
    PodcastFeed();
    Accordion();
    initBrokerModals();
    initRanchBrochureModal();
    PostPreview();
    initImageGallery();
    ShareInfo();
    FilterNavigation();
    InteractiveMap();
    Favorites();

    // Check if ScrollJacking blocks exist and load dynamically
    const hasScrollJacking = document.querySelector('.wp-block-ssm-scroll-jacking');

    if (hasScrollJacking) {
        await ScrollJacking();
    }

    // accessibility fix for forms
    document.querySelectorAll('input, textarea, select').forEach((el) => {
        el.addEventListener('mousedown', () => el.classList.add('mouse-focus'));
        el.addEventListener('blur', () => el.classList.remove('mouse-focus'));
    });
});

import.meta.glob([
    '../../images/**',
    '!../../images/cms/**',
    '../../fonts/**',
]);
